type LatLng = [lat: number, lng: number]

// centers map content inside map UI elements
export const DEFAULT_MAPS_PADDING = {
  top: 100,
  left: 100,
  bottom: 70,
  right: 250,
}

const wholeWorld: LatLng[] = [
  [90, -180], // top left
  [85, 0], // top middle | can not be more than 85 because of a visual bug
  [90, 180], // top right
  [-90, 180], // bottom right
  [-85, 0], // bottom middle | can not be less than 85 because of a visual bug
  [-90, -180], // bottom left
]

export const worldLayer = wholeWorld.map(c => ({ lat: c[0], lng: c[1] }))
